import Avatar from 'components/shared/Avatar/Avatar';
import Divider from 'components/shared/Divider/Divider';
import Icon from 'components/shared/Icon/Icon';

const TrainingDetailsCard = ({ attendees, responsibilities }) => (
  <div className="overflow-hidden rounded-xl border border-solid border-orange-dark-200 bg-orange-dark-50">
    <div className="flex items-center gap-2 px-5 pb-4 pt-5">
      <div className="flex items-center justify-center rounded-lg bg-white p-1.5">
        <Icon icon="chart-presentation-mono" color="warning" shade={600} size={20} />
      </div>
      <h3 className="text-base font-500 text-neutral-900">
        Live training attendees & responsibilities
      </h3>
    </div>

    <div className="flex flex-col gap-5 px-5 pb-5">
      <Divider className="!bg-orange-dark-200" />
      <div className="flex flex-col gap-3">
        <span className="text-sm text-neutral-500">Attendees:</span>
        {attendees.length > 0 ? (
          <div className="flex flex-wrap items-center gap-2">
            {attendees.map((attendee) => (
              <div
                key={attendee.user_id || attendee.id}
                className="flex items-center gap-1.5 rounded-full bg-white py-1 pl-1 pr-3 shadow-[0_1px_2px_rgba(27,33,35,0.06)]">
                <Avatar
                  id={attendee.user_id || attendee.id}
                  firstName={attendee.first_name}
                  lastName={attendee.last_name}
                  size="small"
                  isSquare={false}
                />
                <span className="text-sm font-400 text-neutral-800">
                  {attendee.first_name} {attendee.last_name}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <span className="text-sm font-400 text-neutral-900">No attendees assigned</span>
        )}
      </div>

      <Divider className="!bg-orange-dark-200" />

      <div className="flex flex-col gap-3">
        <span className="text-sm text-neutral-500">Responsibilities:</span>
        <div className="flex flex-col gap-2">
          {responsibilities.map((responsibility, index) => (
            <div key={index} className="flex items-start gap-2">
              <Icon
                icon="checkbox-circle-mono"
                color="warning"
                size={18}
                shade={500}
                className="mt-0.5 flex-shrink-0"
              />
              <span className="text-sm font-400 text-neutral-800">{responsibility}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default TrainingDetailsCard;
